import React, { useState } from 'react';
import { useAuth } from '../components/AuthProvider';

export default function LoginPage({ appTitle = 'Valid8' }) {
	const { needsSetup, login, setup } = useAuth();
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [confirmPassword, setConfirmPassword] = useState('');
	const [error, setError] = useState(null);
	const [loading, setLoading] = useState(false);

	async function handleLogin(e) {
		e.preventDefault();
		setError(null);
		setLoading(true);
		try {
			await login(email, password);
		} catch (err) {
			setError(err.message);
		} finally {
			setLoading(false);
		}
	}

	async function handleSetup(e) {
		e.preventDefault();
		setError(null);

		if (password !== confirmPassword) {
			setError('Passwords do not match.');
			return;
		}
		if (password.length < 6) {
			setError('Password must be at least 6 characters.');
			return;
		}

		setLoading(true);
		try {
			await setup(password);
		} catch (err) {
			setError(err.message);
		} finally {
			setLoading(false);
		}
	}

	if (needsSetup) {
		return (
			<div className="login-page">
				<div className="login-card">
					<h2>Initial Setup</h2>
					<p className="login-subtitle">
						Create a password for <strong>sysadmin@clearmotorclaims.co.uk</strong>
					</p>

					{error && <div className="message error">{error}</div>}

					<form onSubmit={handleSetup}>
						<div className="form-field">
							<label>Password</label>
							<input
								type="password"
								value={password}
								onChange={(e) => setPassword(e.target.value)}
								placeholder="Enter password (min 6 characters)"
								required
								minLength={6}
								disabled={loading}
							/>
						</div>
						<div className="form-field">
							<label>Confirm Password</label>
							<input
								type="password"
								value={confirmPassword}
								onChange={(e) => setConfirmPassword(e.target.value)}
								placeholder="Confirm password"
								required
								disabled={loading}
							/>
						</div>
						<button type="submit" className="btn-primary login-btn" disabled={loading}>
							{loading ? 'Setting up...' : 'Create Account'}
						</button>
					</form>
				</div>
			</div>
		);
	}

	return (
		<div className="login-page">
			<div className="login-card">
				<h2>{appTitle}</h2>
				<p className="login-subtitle">Sign in to continue</p>

				{error && <div className="message error">{error}</div>}

				<form onSubmit={handleLogin}>
					<div className="form-field">
						<label>Email</label>
						<input
							type="email"
							value={email}
							onChange={(e) => setEmail(e.target.value)}
							placeholder="Enter your email"
							required
							disabled={loading}
						/>
					</div>
					<div className="form-field">
						<label>Password</label>
						<input
							type="password"
							value={password}
							onChange={(e) => setPassword(e.target.value)}
							placeholder="Enter your password"
							required
							disabled={loading}
						/>
					</div>
					<button type="submit" className="btn-primary login-btn" disabled={loading}>
						{loading ? 'Signing in...' : 'Sign In'}
					</button>
				</form>
			</div>
		</div>
	);
}
